export const getTab1ValidationRules = (
    values: any,
    pickup: any,
    ispickupDateModified: boolean,
    canadianPhoneRegExp: RegExp
  ) => [
    { condition: !pickup?.city, message: "Pick-Up Address is required" },
    { condition: !values.pickupContactName, message: "Contact Name is required" },
    { condition: ispickupDateModified, message: "Invalid date or time selected" },
    {
      condition: values.pickupContactPhone && !canadianPhoneRegExp.test(values.pickupContactPhone),
      message: "Invalid Canadian phone number",
    },
  ];
  